// // import React, { useCallback, useEffect, useState } from "react";
// // import { NavLink, useNavigate } from "react-router-dom";
// // import { useAuth } from "@/lib/auth";
// // import { PROFILE_TYPE_LABEL } from "@/lib/constants";
// // import { Button } from "@/components/ui/button";
// // import {
// //   DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
// //   DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
// // } from "@/components/ui/dropdown-menu";
// // import { Music2, ChevronDown, Plus, LogOut, User, Bell } from "lucide-react";

// // //emergent code
// // // const NAV = [
// // //   { to: "/explore", label: "Explore", testid: "nav-explore" },
// // //   { to: "/how-it-works", label: "How it works", testid: "nav-how" },
// // //   { to: "/profiles", label: "My Profiles", testid: "nav-profiles" },
// // //   { to: "/applications", label: "Applications", testid: "nav-applications" },
// // // ];

// // //Updated code by kushal
// // const NAV = [
// //   { to: "/explore", label: "Explore", testid: "nav-explore" },
// //   { to: "/how-it-works", label: "How it works", testid: "nav-how" },
// //   { to: "/profiles", label: "My Profiles", testid: "nav-profiles" },
// //   { to: "/my-gigs", label: "My Gigs", testid: "nav-my-gigs" },
// //   { to: "/applications", label: "Applications", testid: "nav-applications" },
// // ];

// // export default function AppLayout({ children }) {
// //   const { account, profiles, activeProfile, switchProfile, logout } = useAuth();
// //   const navigate = useNavigate();
// //   const isVenue = activeProfile?.profile_type === "venue";

// //   return (
// //     <div className="min-h-screen bg-[#FCFCFD]">
// //       <header className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/95 backdrop-blur">
// //         <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-6">
// //           <button onClick={() => navigate("/explore")} className="flex items-center gap-2" data-testid="brand-home">
// //             <div className="w-8 h-8 rounded-lg bg-[#0F172A] text-white grid place-items-center">
// //               <Music2 className="w-4 h-4" />
// //             </div>
// //             <span className="font-display font-bold text-lg tracking-tight">Cadence</span>
// //           </button>

// //           <nav className="hidden md:flex items-center gap-1 ml-2">
// //             {NAV.map((n) => (
// //               <NavLink key={n.to} to={n.to} data-testid={n.testid}
// //                 className={({ isActive }) =>
// //                   `px-3 py-2 text-sm rounded-lg transition-colors ${
// //                     isActive ? "bg-slate-100 text-slate-900" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
// //                   }`
// //                 }>{n.label}</NavLink>
// //             ))}
// //           </nav>

// //           <div className="ml-auto flex items-center gap-3">
// //             {activeProfile && (
// //               <DropdownMenu>
// //                 <DropdownMenuTrigger asChild>
// //                   <button data-testid="profile-switcher"
// //                     className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-1.5 text-sm hover:bg-slate-50">
// //                     <span className="text-slate-500">Using</span>
// //                     <span className="font-medium text-slate-900">{PROFILE_TYPE_LABEL[activeProfile.profile_type]}</span>
// //                     <ChevronDown className="w-4 h-4 text-slate-500" />
// //                   </button>
// //                 </DropdownMenuTrigger>
// //                 <DropdownMenuContent align="end" className="w-64">
// //                   <DropdownMenuLabel>Switch profile</DropdownMenuLabel>
// //                   <DropdownMenuSeparator />
// //                   {profiles.map((p) => (
// //                     <DropdownMenuItem key={p.profile_id} onClick={() => switchProfile(p.profile_id)}
// //                       data-testid={`switch-to-${p.profile_type}`}>
// //                       <div>
// //                         <div className="font-medium">{p.display_name}</div>
// //                         <div className="text-xs text-slate-500">{PROFILE_TYPE_LABEL[p.profile_type]}</div>
// //                       </div>
// //                     </DropdownMenuItem>
// //                   ))}
// //                   <DropdownMenuSeparator />
// //                   <DropdownMenuItem onClick={() => navigate("/profiles/add")} data-testid="add-profile-menu-item">
// //                     <Plus className="w-4 h-4 mr-2" />Add another profile
// //                   </DropdownMenuItem>
// //                 </DropdownMenuContent>
// //               </DropdownMenu>
// //             )}

// //             {isVenue && (
// //               <Button onClick={() => navigate("/opportunities/new")} data-testid="post-gig-cta"
// //                 className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex">
// //                 Post a Gig
// //               </Button>
// //             )}
// //             {activeProfile?.profile_type === "band" && (
// //               <Button onClick={() => navigate("/opportunities/new")} data-testid="post-gig-cta"
// //                 className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex">
// //                 Post a Gig
// //               </Button>
// //             )}

// //             <DropdownMenu>
// //               <DropdownMenuTrigger asChild>
// //                 <button data-testid="account-menu"
// //                   className="w-9 h-9 rounded-full bg-slate-200 grid place-items-center overflow-hidden">
// //                   {account?.picture ? (
// //                     <img src={account.picture} alt="me" className="w-full h-full object-cover" />
// //                   ) : (
// //                     <User className="w-4 h-4 text-slate-600" />
// //                   )}
// //                 </button>
// //               </DropdownMenuTrigger>
// //               <DropdownMenuContent align="end">
// //                 <DropdownMenuLabel>{account?.name}</DropdownMenuLabel>
// //                 <DropdownMenuSeparator />
// //                 <DropdownMenuItem onClick={() => navigate("/profiles")} data-testid="my-profiles-menu">My profiles</DropdownMenuItem>
// //                 <DropdownMenuItem onClick={() => navigate("/settings")} data-testid="settings-menu">Settings</DropdownMenuItem>
// //                 <DropdownMenuSeparator />
// //                 <DropdownMenuItem onClick={logout} data-testid="logout-menu">
// //                   <LogOut className="w-4 h-4 mr-2" />Sign out
// //                 </DropdownMenuItem>
// //               </DropdownMenuContent>
// //             </DropdownMenu>
// //           </div>
// //         </div>
// //         <div className="md:hidden border-t border-slate-100 overflow-x-auto">
// //           <div className="flex px-4 py-2 gap-2">
// //             {NAV.map((n) => (
// //               <NavLink key={n.to} to={n.to}
// //                 className={({ isActive }) =>
// //                   `whitespace-nowrap px-3 py-1.5 text-sm rounded-lg ${isActive ? "bg-slate-100" : "text-slate-600"}`
// //                 }>{n.label}</NavLink>
// //             ))}
// //           </div>
// //         </div>
// //       </header>
// //       <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
// //     </div>
// //   );
// // }











// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { useAuth } from "@/lib/auth";
// import { PROFILE_TYPE_LABEL } from "@/lib/constants";
// import { Button } from "@/components/ui/button";
// import {
//   DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
//   DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
// } from "@/components/ui/dropdown-menu";
// import { Music2, ChevronDown, Plus, LogOut, User, Bell } from "lucide-react";

// const NAV = [
//   { to: "/explore", label: "Explore", testid: "nav-explore" },
//   { to: "/how-it-works", label: "How it works", testid: "nav-how" },
//   { to: "/profiles", label: "My Profiles", testid: "nav-profiles" },
//   { to: "/my-gigs", label: "My Gigs", testid: "nav-my-gigs" },
//   { to: "/applications", label: "Applications", testid: "nav-applications" },
// ];

// export default function AppLayout({ children }) {
//   const { account, profiles, activeProfile, switchProfile, logout } = useAuth();
//   const navigate = useNavigate();
//   const isVenue = activeProfile?.profile_type === "venue";

//   return (
//     <div className="min-h-screen bg-[#FCFCFD]">
//       <header className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/95 backdrop-blur">
//         <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-6">
//           <button onClick={() => navigate("/explore")} className="flex items-center gap-2" data-testid="brand-home">
//             <div className="w-8 h-8 rounded-lg bg-[#0F172A] text-white grid place-items-center">
//               <Music2 className="w-4 h-4" />
//             </div>
//             <span className="font-display font-bold text-lg tracking-tight">Cadence</span>
//           </button>

//           <nav className="hidden md:flex items-center gap-1 ml-2">
//             {NAV.map((n) => (
//               <NavLink key={n.to} to={n.to} data-testid={n.testid}
//                 className={({ isActive }) =>
//                   `px-3 py-2 text-sm rounded-lg transition-colors ${
//                     isActive ? "bg-slate-100 text-slate-900" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
//                   }`
//                 }>{n.label}</NavLink>
//             ))}
//           </nav>

//           <div className="ml-auto flex items-center gap-3">
//             {activeProfile && (
//               <DropdownMenu>
//                 <DropdownMenuTrigger asChild>
//                   <button data-testid="profile-switcher"
//                     className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-1.5 text-sm hover:bg-slate-50">
//                     <span className="text-slate-500">Using</span>
//                     <span className="font-medium text-slate-900">{PROFILE_TYPE_LABEL[activeProfile.profile_type]}</span>
//                     <ChevronDown className="w-4 h-4 text-slate-500" />
//                   </button>
//                 </DropdownMenuTrigger>
//                 <DropdownMenuContent align="end" className="w-64">
//                   <DropdownMenuLabel>Switch profile</DropdownMenuLabel>
//                   <DropdownMenuSeparator />
//                   {profiles.map((p) => (
//                     <DropdownMenuItem key={p.profile_id} onClick={() => switchProfile(p.profile_id)}
//                       data-testid={`switch-to-${p.profile_type}`}>
//                       <div>
//                         <div className="font-medium">{p.display_name}</div>
//                         <div className="text-xs text-slate-500">{PROFILE_TYPE_LABEL[p.profile_type]}</div>
//                       </div>
//                     </DropdownMenuItem>
//                   ))}
//                   <DropdownMenuSeparator />
//                   <DropdownMenuItem onClick={() => navigate("/profiles/add")} data-testid="add-profile-menu-item">
//                     <Plus className="w-4 h-4 mr-2" />Add another profile
//                   </DropdownMenuItem>
//                 </DropdownMenuContent>
//               </DropdownMenu>
//             )}

//             {isVenue && (
//               <Button onClick={() => navigate("/opportunities/new")} data-testid="post-gig-cta"
//                 className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex">
//                 Post a Gig
//               </Button>
//             )}
//             {activeProfile?.profile_type === "band" && (
//               <Button onClick={() => navigate("/opportunities/new")} data-testid="post-gig-cta"
//                 className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex">
//                 Post a Gig
//               </Button>
//             )}

//             <DropdownMenu>
//               <DropdownMenuTrigger asChild>
//                 <button data-testid="account-menu"
//                   className="w-9 h-9 rounded-full bg-slate-200 grid place-items-center overflow-hidden">
//                   {account?.picture ? (
//                     <img src={account.picture} alt="me" className="w-full h-full object-cover" />
//                   ) : (
//                     <User className="w-4 h-4 text-slate-600" />
//                   )}
//                 </button>
//               </DropdownMenuTrigger>
//               <DropdownMenuContent align="end">
//                 <DropdownMenuLabel>{account?.name}</DropdownMenuLabel>
//                 <DropdownMenuSeparator />
//                 <DropdownMenuItem onClick={() => navigate("/profiles")} data-testid="my-profiles-menu">My profiles</DropdownMenuItem>
//                 <DropdownMenuItem onClick={() => navigate("/settings")} data-testid="settings-menu">Settings</DropdownMenuItem>
//                 <DropdownMenuSeparator />
//                 <DropdownMenuItem onClick={logout} data-testid="logout-menu">
//                   <LogOut className="w-4 h-4 mr-2" />Sign out
//                 </DropdownMenuItem>
//               </DropdownMenuContent>
//             </DropdownMenu>
//           </div>
//         </div>
//         <div className="md:hidden border-t border-slate-100 overflow-x-auto">
//           <div className="flex px-4 py-2 gap-2">
//             {NAV.map((n) => (
//               <NavLink key={n.to} to={n.to}
//                 className={({ isActive }) =>
//                   `whitespace-nowrap px-3 py-1.5 text-sm rounded-lg ${isActive ? "bg-slate-100" : "text-slate-600"}`
//                 }>{n.label}</NavLink>
//             ))}
//           </div>
//         </div>
//       </header>
//       <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
//     </div>
//   );
// }






import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { PROFILE_TYPE_LABEL } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Music2, ChevronDown, Plus, LogOut, User, Bell } from "lucide-react";

const NAV = [
  { to: "/explore", label: "Explore", testid: "nav-explore" },
  { to: "/how-it-works", label: "How it works", testid: "nav-how" },
  { to: "/profiles", label: "My Profiles", testid: "nav-profiles" },
  { to: "/my-gigs", label: "My Gigs", testid: "nav-my-gigs" },
  { to: "/applications", label: "Applications", testid: "nav-applications" },
];

export default function AppLayout({ children }) {
  const { account, profiles, activeProfile, switchProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const isVenue = activeProfile?.profile_type === "venue";
  const visibleNav = account
    ? NAV
    : NAV.filter((item) => ["/explore", "/how-it-works"].includes(item.to));

  const startGoogleSignIn = () => {
    const redirectUri = window.location.origin + "/auth/callback";
    const params = new URLSearchParams({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "offline",
      prompt: "consent",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  const refreshNotifications = useCallback(async () => {
    if (!account) {
      setUnreadCount(0);
      return;
    }
    try {
      const { data } = await api.get("/notifications");
      setUnreadCount(data.unread_count || 0);
    } catch {
      setUnreadCount(0);
    }
  }, [account]);

  useEffect(() => {
    if (!account) {
      setUnreadCount(0);
      return undefined;
    }
    refreshNotifications();
    const interval = setInterval(refreshNotifications, 15000);
    window.addEventListener("notifications:refresh", refreshNotifications);
    return () => {
      clearInterval(interval);
      window.removeEventListener("notifications:refresh", refreshNotifications);
    };
  }, [account, refreshNotifications]);

  return (
    <div className="min-h-screen bg-[#FCFCFD]">
      <header className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-6">
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2"
            data-testid="brand-home"
            aria-label="Go to dashboard"
          >
            <div className="w-8 h-8 rounded-lg bg-[#0F172A] text-white grid place-items-center">
              <Music2 className="w-4 h-4" />
            </div>
            <span className="font-display font-bold text-lg tracking-tight">
              Showfex
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-1 ml-2">
            {visibleNav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-lg transition-colors ${
                    isActive
                      ? "bg-slate-100 text-slate-900"
                      : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            {activeProfile && (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button
                    data-testid="profile-switcher"
                    className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-1.5 text-sm hover:bg-slate-50"
                  >
                    <span className="text-slate-500">Using</span>
                    <span className="font-medium text-slate-900">
                      {PROFILE_TYPE_LABEL[activeProfile.profile_type]}
                    </span>
                    <ChevronDown className="w-4 h-4 text-slate-500" />
                  </button>
                </DropdownMenuTrigger>

                <DropdownMenuContent align="end" className="w-64">
                  <DropdownMenuLabel>Switch profile</DropdownMenuLabel>
                  <DropdownMenuSeparator />

                  {profiles.map((p) => (
                    <DropdownMenuItem
                      key={p.profile_id}
                      onClick={() => switchProfile(p.profile_id)}
                      data-testid={`switch-to-${p.profile_type}`}
                    >
                      <div>
                        <div className="font-medium">{p.display_name}</div>
                        <div className="text-xs text-slate-500">
                          {PROFILE_TYPE_LABEL[p.profile_type]}
                        </div>
                      </div>
                    </DropdownMenuItem>
                  ))}

                  <DropdownMenuSeparator />

                  <DropdownMenuItem
                    onClick={() => navigate("/profiles/add")}
                    data-testid="add-profile-menu-item"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Add another profile
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}

            {isVenue && (
              <Button
                onClick={() => navigate("/opportunities/new")}
                data-testid="post-gig-cta"
                className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex"
              >
                Post a Gig
              </Button>
            )}

            {activeProfile?.profile_type === "band" && (
              <Button
                onClick={() => navigate("/opportunities/new")}
                data-testid="post-gig-cta"
                className="bg-[#4F46E5] hover:bg-[#4338CA] text-white hidden sm:inline-flex"
              >
                Post a Gig
              </Button>
            )}

            {account && (
              <button
                type="button"
                onClick={() => navigate("/notifications")}
                aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ""}`}
                title="Notifications"
                data-testid="notifications-button"
                className="relative w-9 h-9 rounded-full border border-slate-200 grid place-items-center text-slate-600 hover:bg-slate-50"
              >
                <Bell className="w-4 h-4" />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-rose-600 text-white text-[10px] leading-4 text-center">
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
              </button>
            )}

            {!account && (
              <Button
                onClick={startGoogleSignIn}
                className="bg-[#0F172A] hover:bg-[#1E293B] text-white"
                data-testid="guest-signin"
              >
                Sign in
              </Button>
            )}

            {account && (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button
                    data-testid="account-menu"
                    className="w-9 h-9 rounded-full bg-slate-200 grid place-items-center overflow-hidden"
                  >
                    {account?.picture ? (
                      <img
                        src={account.picture}
                        alt="me"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <User className="w-4 h-4 text-slate-600" />
                    )}
                  </button>
                </DropdownMenuTrigger>
  
                <DropdownMenuContent align="end">
                  <DropdownMenuLabel>{account?.name}</DropdownMenuLabel>
                  <DropdownMenuSeparator />
  
                  <DropdownMenuItem
                    onClick={() => navigate("/profiles")}
                    data-testid="my-profiles-menu"
                  >
                    My profiles
                  </DropdownMenuItem>
  
                  <DropdownMenuItem
                    onClick={() => navigate("/settings")}
                    data-testid="settings-menu"
                  >
                    Settings
                  </DropdownMenuItem>
  
                  <DropdownMenuSeparator />
  
                  <DropdownMenuItem
                    onClick={logout}
                    data-testid="logout-menu"
                  >
                    <LogOut className="w-4 h-4 mr-2" />
                    Sign out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
        </div>

        <div className="md:hidden border-t border-slate-100 overflow-x-auto">
          <div className="flex px-4 py-2 gap-2">
            {visibleNav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `whitespace-nowrap px-3 py-1.5 text-sm rounded-lg ${
                    isActive ? "bg-slate-100" : "text-slate-600"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
